import actions from 'store/actions'

import { default as appTypes } from './types'

const updatingActions = actions.createUpdatingActions(appTypes)

export default {
  ...updatingActions,
}
